var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.7,435.79a124.26,124.26,0,0,0,38.24-43.52c57.16-107.09,44.25-265-65.83-332.73C334.23,28.24,261,8.43,206,40.57c-44.6,26.08-71.94,75.17-94.56,119.83C97.23,188.49,85.52,218.72,68,245c-22.72,34.08-47.73,79.6-22.48,119.2,34.41,53.94,99.4,78.57,158.33,94.79,63.94,17.59,135.84,20.08,194.9-14.23Q405.92,440.59,412.7,435.79Z",
    style: {
      fill: "#BE9C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.7,435.79a124.26,124.26,0,0,0,38.24-43.52c57.16-107.09,44.25-265-65.83-332.73C334.23,28.24,261,8.43,206,40.57c-44.6,26.08-71.94,75.17-94.56,119.83C97.23,188.49,85.52,218.72,68,245c-22.72,34.08-47.73,79.6-22.48,119.2,34.41,53.94,99.4,78.57,158.33,94.79,63.94,17.59,135.84,20.08,194.9-14.23Q405.92,440.59,412.7,435.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.34,387c2.32,1,8,.88,8,.88s-1.22-3.71-1.33-3.94c-1.24-2.6-5.18-6.9-8.38-6.47a3.83,3.83,0,0,0-3.07,4.8C379.09,384.49,381.37,386.14,383.34,387Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3,403.44c2.41.35,7.47-1.12,7.87-1.24a68.4,68.4,0,0,0,3.07,8.5c.7,1.61,1.45,3.21,2.22,4.81-.46-.68-.88-1.28-.94-1.36-1.89-2.18-6.82-5.29-9.8-4a3.82,3.82,0,0,0-1.69,5.43c1.09,2,3.73,3,5.86,3.3s6.5-.85,7.65-1.18c.3.61.6,1.23.9,1.83,1.47,2.92,2.95,5.83,4.31,8.72.47,1,.91,2,1.35,3.07-.41-.6-.76-1.11-.82-1.18-1.89-2.18-6.82-5.29-9.8-4a3.82,3.82,0,0,0-1.69,5.43c1.1,2,3.73,3,5.86,3.3s6.08-.74,7.44-1.12c.42,1.06.84,2.12,1.2,3.17.23.72.5,1.39.68,2.13s.41,1.44.6,2.15c.34,1.38.69,2.8,1,4.16.2.94.38,1.84.57,2.75-.47-1-1.42-3-1.52-3.16-1.53-2.44-5.94-6.26-9.07-5.46a3.83,3.83,0,0,0-2.5,5.11c.79,2.14,3.24,3.52,5.3,4.15,2.27.69,7.29.06,7.92,0,.3,1.51.58,3,.82,4.35.18,1,.35,2,.5,3h2c-.19-1.05-.4-2.16-.63-3.31-.3-1.52-.65-3.15-1-4.81a42.88,42.88,0,0,0,4.42-2.08c1.65,1.79,5.89,3.89,6.44,4.15-.58,1.42-1.16,2.8-1.72,4.08-.3.69-.58,1.33-.87,2h2.13c.17-.4.33-.8.51-1.22.59-1.44,1.19-3,1.8-4.58.6.12,5.58,1.13,7.9.61,2.1-.47,4.64-1.66,5.59-3.74a3.83,3.83,0,0,0-2.12-5.29c-3.06-1-7.73,2.45-9.45,4.77-.1.14-1,1.75-1.6,2.78.24-.66.49-1.29.73-2,.49-1.33.94-2.67,1.43-4.12.21-.7.42-1.42.64-2.14s.38-1.48.57-2.23c.42-1.75.75-3.55,1.05-5.36,1.17.43,5.34,1.88,7.5,1.72s4.85-.94,6.09-2.85a3.82,3.82,0,0,0-1.28-5.54c-2.87-1.48-8,1.25-10.07,3.28-.13.13-1.43,1.75-2.13,2.66.17-1.09.35-2.18.49-3.29.4-3.2.7-6.46,1-9.71.1-1,.21-2,.31-3,.42.15,5.34,2,7.76,1.82,2.14-.15,4.84-.94,6.09-2.86a3.82,3.82,0,0,0-1.29-5.54c-2.87-1.48-8,1.25-10.06,3.28-.16.16-2,2.5-2.48,3.12.23-2.19.48-4.36.82-6.49a65.92,65.92,0,0,1,1.86-8.54c.19.08,5.32,2,7.79,1.84,2.15-.15,4.85-.94,6.1-2.85A3.83,3.83,0,0,0,447.6,395c-2.87-1.48-8,1.25-10.07,3.29-.16.16-2.17,2.68-2.5,3.16.05-.16.08-.34.13-.5a49.47,49.47,0,0,1,3.38-8.07c.73-1.44,1.52-2.77,2.31-4.05.92.45,5.13,2.5,7.38,2.59s4.92-.4,6.37-2.17a3.83,3.83,0,0,0-.67-5.65c-2.69-1.79-8.11.36-10.37,2.16-.12.1-1.26,1.23-2.07,2.07.36-.57.73-1.17,1.09-1.71,1.35-2,2.71-3.82,3.94-5.39.7-.88,1.35-1.67,2-2.4,1.13,0,5.7-.16,7.7-1.1s4.18-2.62,4.66-4.85a3.83,3.83,0,0,0-3.2-4.71c-3.22-.35-7,4.05-8.21,6.69-.1.23-1.28,4-1.22,4h.07c-.61.69-1.25,1.44-1.94,2.27-1.25,1.55-2.66,3.3-4.06,5.32a67.66,67.66,0,0,0-4.22,6.71,50.35,50.35,0,0,0-3.6,8.1s0,.07,0,.11c0-.95,0-3.6-.06-3.8-.37-2.86-2.77-8.18-5.94-8.76A3.82,3.82,0,0,0,424,391.9c-.19,2.28,1.46,4.55,3.07,6,1.81,1.62,6.84,3.19,7.24,3.31a65.81,65.81,0,0,0-2.12,8.78c-.31,1.73-.57,3.48-.81,5.24,0-.82,0-1.55,0-1.66-.37-2.86-2.77-8.17-5.95-8.76a3.83,3.83,0,0,0-4.41,3.6c-.18,2.27,1.47,4.55,3.07,6s5.9,2.88,7,3.24c-.08.67-.17,1.35-.25,2-.39,3.25-.76,6.48-1.23,9.65-.16,1.11-.36,2.21-.56,3.3,0-.73,0-1.34,0-1.43-.37-2.86-2.77-8.18-5.94-8.76a3.83,3.83,0,0,0-4.42,3.59c-.18,2.28,1.47,4.55,3.08,6s5.48,2.74,6.82,3.17c-.24,1.12-.47,2.23-.75,3.3-.21.73-.35,1.44-.6,2.16l-.69,2.12c-.48,1.34-1,2.72-1.48,4-.35.9-.69,1.75-1,2.61.17-1.11.47-3.29.48-3.47a14.87,14.87,0,0,0-2-7.23,4,4,0,0,0-.05-.84,3.83,3.83,0,0,0-4.68-3.25c-3.12.83-5.1,6.32-5.25,9.2,0,.17.11,2,.2,3.19-.16-.68-.31-1.34-.48-2-.32-1.38-.69-2.75-1.08-4.22-.21-.71-.43-1.42-.65-2.14s-.5-1.45-.75-2.18c-.62-1.69-1.33-3.37-2.08-5.05,1.21-.29,5.49-1.38,7.21-2.7s3.52-3.46,3.5-5.74a3.81,3.81,0,0,0-4.13-3.91c-3.21.34-6,5.46-6.58,8.29,0,.18-.23,2.25-.31,3.39-.46-1-.91-2-1.41-3-1.44-2.89-3-5.77-4.51-8.66-.47-.88-.92-1.76-1.38-2.65.43-.1,5.54-1.28,7.47-2.76,1.71-1.31,3.52-3.46,3.5-5.74a3.81,3.81,0,0,0-4.13-3.91c-3.21.34-6,5.46-6.58,8.29,0,.21-.31,3.2-.35,4-1-1.95-2-3.9-2.9-5.86a67.62,67.62,0,0,1-3.15-8.15c.2,0,5.54-1.26,7.51-2.77,1.71-1.31,3.53-3.46,3.51-5.74a3.82,3.82,0,0,0-4.13-3.91c-3.21.34-6,5.46-6.58,8.29-.05.22-.34,3.43-.35,4-.05-.16-.12-.32-.17-.48a49.08,49.08,0,0,1-1.63-8.61c-.18-1.6-.26-3.14-.31-4.65,1-.12,5.66-.74,7.59-1.91s3.88-3.05,4.11-5.32a3.81,3.81,0,0,0-3.67-4.34c-3.23,0-6.57,4.77-7.46,7.52,0,.15-.37,1.72-.59,2.87,0-.68,0-1.38,0-2,0-2.45.16-4.68.31-6.67.1-1.12.21-2.14.32-3.09.93-.64,4.67-3.28,5.82-5.16s2-4.5,1.2-6.62a3.82,3.82,0,0,0-5.26-2.16c-2.87,1.48-3.63,7.26-3.15,10.11,0,.24,1.12,4,1.17,4l.06,0c-.13.91-.25,1.89-.37,3-.19,2-.4,4.23-.45,6.68a67,67,0,0,0,.18,7.92,50,50,0,0,0,1.47,8.75l0,.1c-.51-.8-2-3-2.14-3.14-1.89-2.18-6.82-5.29-9.8-4a3.83,3.83,0,0,0-1.69,5.44C380.54,402.14,383.17,403.12,385.3,403.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.72,388.25s1-3.77,1.06-4c.4-2.86-.51-8.62-3.42-10a3.81,3.81,0,0,0-5.2,2.3c-.78,2.14.2,4.77,1.38,6.58C435.91,385.23,440.71,388.25,440.72,388.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 308,
    width: 70.71,
    height: 149,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 314.57,
    width: 70.71,
    height: 135.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 342.35,
    width: 70.71,
    height: 90.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 352.45,
    width: 70.71,
    height: 72.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.06,
    y: 352.45,
    width: 58.59,
    height: 72.23,
    style: {
      fill: "#5e5e5e",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.32 363.05 58.39 363.05 53.34 352.45 103.37 352.45 98.32 363.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.03,
    y: 425.8,
    width: 5.16,
    height: 5.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 425.8,
    width: 5.16,
    height: 5.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.52,
    y: 425.8,
    width: 5.16,
    height: 5.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.98,
    y: 315.17,
    width: 4.44,
    height: 26.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 315.17,
    width: 2.22,
    height: 26.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.98,
    y: 433.04,
    width: 4.44,
    height: 17.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 433.04,
    width: 2.22,
    height: 17.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.81,
    y: 315.17,
    width: 2.22,
    height: 26.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.81,
    y: 433.04,
    width: 2.22,
    height: 17.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.2,221.33s-2.34,8.67-1.67,16.34a40.54,40.54,0,0,0,9.67,23c6.33,7.66,36.66,62.66,41,67.33s22,26.33,21.33,36-5.67,8.33-19.67,3.67-20-8-20-8,1,33.33,2.34,48,8,48.66,8,48.66h-129s12-34.33,16.33-48.66a200.76,200.76,0,0,0,7-34c.33-4.34-17-53.34-20-61s-11.68-27-8.67-38c2.37-8.64,11.77-19.65,27-23.34,7.95-1.92,21.67-12,26.34-19.66,3.55-5.85,8.33-22.34,3-35s-4.67-22.67,2.66-29.34,21.34-11.33,33.34-8,16.33,12,13.66,22.34S278.2,221.33,278.2,221.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,213.18s3.94,12.8,9.19,18.37,7.36,6.12,7.36,6.12-.65-7.71.51-12C277,225.65,265.23,219.74,260,213.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,264.57c1.15.8,2,1.49,2,1.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.31,255.15s25.29,6.45,27.77,7.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.53,237.67s.93,17,1.43,20.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,407.67c-1.34-14.67-2.34-48-2.34-48S315.7,334.5,313.7,323c-1.1-6.33-9.33-27.38-16.51-45-2.87-4.83-5.46-9.1-7.51-12.3a79.41,79.41,0,0,1,4,10.81c3,11,2.83,24.17-15.17,26.17S243.2,278,238.2,268.5c-3.6-6.84-12.39-16.53-17-21.42a41.08,41.08,0,0,1-7.37,3.65c4.37,2.89,11.63,9.14,18.89,21.77,11.5,20,12,45,4.5,54-7,8.38-20,13.29-37.57,3,6.06,17.24,14.13,41.19,13.9,44.16a200.76,200.76,0,0,1-7,34C202.2,422,190.2,456.33,190.2,456.33h129S312.53,422.33,311.2,407.67Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,383.67c-14.1,16.66-35,40-49.76,50.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.23,365.07s-4.45,5.66-11.29,13.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,430c-2.56,1.77-4.77,3.22-6.45,4.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.37,397.84s-22.73,18.29-38.08,29.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,207.67s6,11,16.67,16.66,26,10.34,28.33,9.34,7.34-16.34,7.34-16.34l2.33-2,.33-5.66s6.67-2,6.67-3.67-4.67-10-6-14,4.67-9.67,4.67-12.33-.34-12.67-.34-12.67,1-5.67-5.66-12.33-35-1-44.67,5-10.67,10-10.67,10",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "311.35 208.25 308.1 209.75 306.85 207.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,179.67a11.51,11.51,0,0,1,13-1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,185v5.33s-3.34,1.34-8-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.92,190.65s-6,1.29-10-1.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.86,119.67s7.67-2.34,7.67-10.67-17.67-17.67-34-14-27.67,24.33-21.67,32.67,17.34,7,21,4.66S253.53,123,253.53,123Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.83,185.25s6.53,1,10.55-2,7-10.55,9-12.06,6.54.5,12.57-1.51,13.06-8.54,13.06-8.54l-.5,8.54a132.25,132.25,0,0,1,14.07-.5c10.05,0,14.07-2.51,14.07-2.51A46.1,46.1,0,0,0,320.15,140c-8-13.07-38.18-20.1-55.77-21.61s-33.67,8.54-40.7,22.11-12.85,47.72-.54,62c23,26.7,26.16-9.24,26.67-11.25S253.83,185.25,253.83,185.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,187.26s-5.53-17.59-12.06-14.57-1,20.6,3,23.11,5.52-1.51,5.52-1.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,351.33s2-5.66,4-19,1.34-48.66-.33-52-7.67-18-7.33-23.66,22.33-20.67,25.33-21,8,5.33,8,9.66-14,23.34-14,23.34.33,7.66,2.67,13.33,14.33,44.33,12.66,63.67-2.33,25.33-7.66,26-21.67-6-21.67-6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.58,220.58s-2.08-4.72-3.78-5.86-8.69-1.13-7.75.95,4.92,2.08,4.92,2.08l3.21,3S344.39,223.6,344.58,220.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,238.77l-16.33-23.64c-2.74-5.59-11.75-6.8-20.13-2.7s-13,12-10.22,17.55a7.74,7.74,0,0,0,2.22,2.73l14.12,20.91Z",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.37,
    cy: 246.2,
    rx: 16.89,
    ry: 11.27,
    transform: "translate(-74.09 172.49) rotate(-26.08)",
    style: {
      fill: "#BE9C79",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.86,262s15.75,8.56,20.93,29.62c3.08,12.51,32.07,44.05,32.07,44.05s11-70.34,11-81,21.67-34,24.67-35,11-3.34,14-1a7.73,7.73,0,0,1,3,5.66A14,14,0,0,1,323.2,230a13.09,13.09,0,0,1-.34,3.67,12.8,12.8,0,0,1,.67,5.33,13.32,13.32,0,0,1-1,4,18.19,18.19,0,0,1-3,9.33c-3,4.34-13.33,11-17.67,13.34a47.71,47.71,0,0,0-9,7s6,49.33,4.67,71.66-8,36-12.33,37-15.34-2-35.67-18-50.33-51-57-57.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,224.33s-11.33,3.67-13,5.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.86,
    y1: 233.67,
    x2: 313.53,
    y2: 238.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,243s-7.33,1.67-7.67,2.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,223.31s-3.93-5.73-6.38-5.89-6.38,1.64-5.24,3.11,4.26,1.14,5.24,1.14,5.56,2.46,5.56,2.46S346.61,224.13,346.45,223.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.56,231.49a22,22,0,0,0-2.7-7.49c-2-3-11.33-3-9.33,0s6,2,7,3,5,7,5,7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.86,238.67s-.66-6.67-3-9-9-2-7,0L349.2,237S351.2,242,351.86,238.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79,204.82a24.38,24.38,0,0,1,4.36-.83c8.52-.9,11.75,2,21.52-.45,14.35-3.58,15.66-14.37,8.52-16.13s-7.62,6.72-6.28,8.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.29,208.47a4.89,4.89,0,0,1,1.74-1.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,197a10.07,10.07,0,0,0,5.52-1.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.15,203.54a14,14,0,0,1,12.11-7.17c3.35,0,6,.28,8.24.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,179.26s.31,8.78-4.08,16a28.35,28.35,0,0,1-2.91,3.8l-1.32,1.48c-5.32,5.86-12,12.68-8.64,23,4.39,13.5,17.58,4.08,17.58,4.08s-9.73,1.88-13.81-7.54,1.57-16.95,7.22-19.14,14.44-17.58,10.36-28.26",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-43"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 468.73,
    y1: 456.36,
    x2: 480.05,
    y2: 456.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.82,
    y1: 456.36,
    x2: 461.2,
    y2: 456.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.7b0793e9616db51aaaf8a9b73239adef.svg";
export { ForwardRef as ReactComponent };